export default __webpack_public_path__ + "static/media/authPerson.be50a571.png";